import { Module } from "vuex";
import { actions, PROMO_CODES_ACTIONS } from "./actions";
import { mutations, PROMO_CODES_MUTATIONS } from "./mutations";
import { IPromoCodesState } from "./types";
import { IRootState } from "@/store/types";
import { cloneDeep } from "@/helpers/object";

const defaultBenefits = {
  type: "doc",
  content: [
    {
      type: "paragraph",
      content: [
        {
          type: "text",
          text: "Get Fly Buys or Airpoints on fuel purchases at Z & Caltex service stations."
        }
      ]
    }
  ]
};

const defaultLegal = {
  type: "doc",
  content: [
    {
      type: "paragraph",
      content: []
    }
  ]
};

export const state: IPromoCodesState = {
  isLoading: false,
  promoCodesList: [],
  promoCode: {
    id: 0,
    promoCode: "",
    singleUse: false,
    membershipNoRequired: false,
    validFromDate: null,
    validToDate: null,
    benefits: JSON.stringify(defaultBenefits),
    benefitsHtml: "",
    legal: JSON.stringify(defaultLegal),
    legalHtml: "",
    earnsLoyaltyPoints: false,
    skipCreditCheck: false,
    isDiscountOffPump: true,
    discounts: null,
    paymentTerm: "",
    paymentMethod: "DirectDebit",
    deliveryMethod: "StandardPost",
    accountFeeProfile: "",
    cardFeeProfile: "",
    applicationType: "",
    customerType: "",
    classOfBuyer: "",
    pricingProfile: "",
    rebateProfile: [""],
    collectionManager: "",
    salesRepresentative: ""
  },
  dataTable: {
    pagination: {
      sortBy: "createdDate"
    }
  }
};

export namespace PROMO_CODES {
  export const ACTIONS = PROMO_CODES_ACTIONS;
  export const MUTATIONS = PROMO_CODES_MUTATIONS;
  export const NAME_SPACE = "promoOffer";
  export const NS = (x: string): string => `${NAME_SPACE}/${x}`;
}

const namespaced: boolean = true;

export const promoCodes: Module<IPromoCodesState, IRootState> = {
  namespaced,
  state: cloneDeep(state), // create a deep clone of state object so we can reuse the state object
  actions,
  mutations
};
